import { useApiDataService } from './use-api-data-service';
import { ConversationService } from 'services/conversation-service';

export const useConversationService = () => useApiDataService<ConversationService>(ConversationService);
export default useConversationService;
